import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  "data-index": 0
}
const _hoisted_2 = {
  key: 1,
  class: "container",
  "data-index": 1
}
const _hoisted_3 = {
  key: 2,
  class: "container",
  "data-index": 2
}
const _hoisted_4 = {
  key: 3,
  class: "container",
  "data-index": 3
}
const _hoisted_5 = {
  key: 4,
  class: "container",
  "data-index": 4
}
const _hoisted_6 = {
  key: 5,
  class: "container",
  "data-index": 5,
  style: {"padding-bottom":"5px"}
}
const _hoisted_7 = {
  key: 6,
  class: "container",
  "data-index": 6
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { style: {"display":"flex","margin":"auto"} }
const _hoisted_10 = {
  class: "container",
  key: 7,
  "data-index": 7
}
const _hoisted_11 = {
  class: "container",
  key: 8,
  "data-index": 8
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_test_select = _resolveComponent("test-select")!
  const _component_icon = _resolveComponent("icon")!
  const _component_test_check = _resolveComponent("test-check")!
  const _component_searchable_select = _resolveComponent("searchable-select")!

  return (_openBlock(), _createElementBlock("div", {
    name: "game",
    appear: "",
    onBeforeEnter: _cache[36] || (_cache[36] = (el) => _ctx.beforeEnter(<HTMLElement>el)),
    onEnter: _cache[37] || (_cache[37] = (el, done) => _ctx.enter(<HTMLElement>el, done))
  }, [
    (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.launchEmulator && _ctx.launchEmulator(...args)))
      }, "Launch Emulator"),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.popout && _ctx.popout(...args)))
      }, "Open In New Window")
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_2, [
      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "title" }, "Set up", -1)),
      _createVNode(_component_test_select, {
        title: "Game",
        icon: "gamepad",
        "option-data": _ctx.gameOptions,
        "selected-option": _ctx.parameters.game,
        onUpdate: _cache[2] || (_cache[2] = ($event: any) => {_ctx.updateGameConfigs($event);})
      }, null, 8, ["option-data", "selected-option"]),
      (_ctx.parameters.game.getConfigs().length > 1)
        ? (_openBlock(), _createBlock(_component_test_select, {
            key: 0,
            title: "Config",
            icon: "cogs",
            "option-data": _ctx.parameters.game.getConfigs(),
            "selected-option": _ctx.parameters.game.selectedConfig,
            onUpdate: _cache[3] || (_cache[3] = ($event: any) => {
        _ctx.parameters.game.selectedConfig = $event
        _ctx.loadGame();
        })
          }, null, 8, ["option-data", "selected-option"]))
        : _createCommentVNode("", true),
      (_ctx.parameters.game.getVersions().length > 1)
        ? (_openBlock(), _createBlock(_component_test_select, {
            key: 1,
            title: "Version",
            icon: "hashtag",
            "option-data": _ctx.parameters.game.getVersions(),
            "selected-option": _ctx.parameters.game.version,
            onUpdate: _cache[4] || (_cache[4] = ($event: any) => {
        _ctx.parameters.game.version = $event
        _ctx.loadGame();
        })
          }, null, 8, ["option-data", "selected-option"]))
        : _createCommentVNode("", true),
      _createVNode(_component_test_select, {
        title: "Environment",
        icon: "globe",
        "option-data": _ctx.environments,
        "selected-option": _ctx.parameters.environment,
        onUpdate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.parameters.environment = $event))
      }, null, 8, ["option-data", "selected-option"])
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_3, [
      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "title" }, "User", -1)),
      _createVNode(_component_test_select, {
        title: "Integration",
        icon: "chain",
        "option-data": _ctx.integrations,
        "selected-option": _ctx.parameters.integration,
        onUpdate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.parameters.integration = $event))
      }, null, 8, ["option-data", "selected-option"]),
      _createVNode(_component_test_select, {
        title: "Operator",
        icon: "child",
        "option-data": _ctx.parameters.integration.operators,
        "selected-option": _ctx.parameters.integration.operator,
        onUpdate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.parameters.integration.operator = $event))
      }, null, 8, ["option-data", "selected-option"]),
      _createElementVNode("div", null, [
        _createVNode(_component_icon, { icon: "signature" }),
        _cache[39] || (_cache[39] = _createTextVNode(" Player ID ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.parameters.playerId) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "..."
        }, null, 512), [
          [
            _vModelText,
            _ctx.parameters.playerId,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_icon, { icon: "key" }),
        _cache[40] || (_cache[40] = _createTextVNode(" Token ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.parameters.token) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "...",
          readonly: ""
        }, null, 512), [
          [
            _vModelText,
            _ctx.parameters.token,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetUser && _ctx.resetUser(...args)))
      }, "Reset User")
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_4, [
      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "title" }, "Locale", -1)),
      _createVNode(_component_test_select, {
        title: "Language",
        icon: "flag",
        "option-data": _ctx.languages,
        "selected-option": _ctx.parameters.language,
        onUpdate: _cache[11] || (_cache[11] = ($event: any) => (_ctx.parameters.language = $event))
      }, null, 8, ["option-data", "selected-option"]),
      _createVNode(_component_test_select, {
        title: "Currency",
        icon: "coins",
        "option-data": _ctx.currencies,
        "selected-option": _ctx.parameters.currency,
        onUpdate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.parameters.currency = $event))
      }, null, 8, ["option-data", "selected-option"]),
      _createVNode(_component_test_select, {
        title: "Play Mode",
        icon: "play",
        "option-data": _ctx.playModes,
        "selected-option": _ctx.parameters.playMode,
        onUpdate: _cache[13] || (_cache[13] = ($event: any) => (_ctx.parameters.playMode = $event))
      }, null, 8, ["option-data", "selected-option"]),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.setSocial && _ctx.setSocial(...args)))
      }, "Social")
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_5, [
      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "title" }, "Start Balance", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.parameters.balance) = $event)),
        type: "number",
        class: "textInput",
        placeholder: ""
      }, null, 512), [
        [_vModelText, _ctx.parameters.balance]
      ]),
      _createVNode(_component_test_check, {
        title: "Force Balance",
        icon: "globe",
        reference: _ctx.parameters.forceBalance,
        onUpdate: _cache[16] || (_cache[16] = ($event: any) => (_ctx.parameters.forceBalance = $event))
      }, null, 8, ["reference"])
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_6, [
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "title" }, "Testing", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_icon, { icon: "signature" }),
        _cache[44] || (_cache[44] = _createTextVNode(" Extra Query Params ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.parameters.queryParams) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "&queryParam=test"
        }, null, 512), [
          [_vModelText, _ctx.parameters.queryParams]
        ])
      ]),
      _createVNode(_component_test_check, {
        title: "Random Delay",
        icon: "clock",
        reference: _ctx.parameters.delay,
        onUpdate: _cache[18] || (_cache[18] = ($event: any) => (_ctx.parameters.delay = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Turbo",
        icon: "bolt-lightning",
        reference: _ctx.parameters.turbo,
        onUpdate: _cache[19] || (_cache[19] = ($event: any) => (_ctx.parameters.turbo = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Auto Play",
        icon: "clock",
        reference: _ctx.parameters.autoplay,
        onUpdate: _cache[20] || (_cache[20] = ($event: any) => (_ctx.parameters.autoplay = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Net Position",
        icon: "coins",
        reference: _ctx.parameters.netPosition,
        onUpdate: _cache[21] || (_cache[21] = ($event: any) => (_ctx.parameters.netPosition = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Force Demo",
        icon: "user-secret",
        reference: _ctx.parameters.forceDemo,
        onUpdate: _cache[22] || (_cache[22] = ($event: any) => (_ctx.parameters.forceDemo = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Force Custom error",
        icon: "globe",
        reference: _ctx.parameters.forceCustomError,
        onUpdate: _cache[23] || (_cache[23] = ($event: any) => (_ctx.parameters.forceCustomError = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Home/Lobby Button",
        icon: "user-secret",
        reference: _ctx.parameters.homeButtonEnabled,
        onUpdate: _cache[24] || (_cache[24] = ($event: any) => (_ctx.parameters.homeButtonEnabled = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Deposit/Wallet Button",
        icon: "user-secret",
        reference: _ctx.parameters.depositEnabled,
        onUpdate: _cache[25] || (_cache[25] = ($event: any) => (_ctx.parameters.depositEnabled = $event))
      }, null, 8, ["reference"]),
      _createVNode(_component_test_check, {
        title: "Game History",
        icon: "user-secret",
        reference: _ctx.parameters.historyEnabled,
        onUpdate: _cache[26] || (_cache[26] = ($event: any) => (_ctx.parameters.historyEnabled = $event))
      }, null, 8, ["reference"])
    ])),
    (_ctx.parameters.game.selectedConfig.outcomes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "title" }, "Outcomes", -1)),
          _createVNode(_component_searchable_select, {
            title: "Outcome",
            icon: "list",
            "option-data": _ctx.parameters.game.selectedConfig.outcomes,
            "selected-option": _ctx.parameters.game.selectedConfig.selectedOutcome,
            onUpdate: _cache[27] || (_cache[27] = ($event: any) => {
          _ctx.parameters.game.selectedConfig.selectedOutcome = $event;
          _ctx.sequence = _ctx.parameters.game.selectedConfig.selectedOutcome.sequence;
        })
          }, null, 8, ["option-data", "selected-option"]),
          _createElementVNode("input", {
            value: _ctx.sequence,
            type: "text",
            class: "textInput",
            placeholder: "",
            onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sequence = (<HTMLInputElement>$event.target).value))
          }, null, 40, _hoisted_8),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.sendOutcome && _ctx.sendOutcome(...args)))
            }, "SEND"),
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.clearOutcome && _ctx.clearOutcome(...args)))
            }, "CLEAR")
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock("div", _hoisted_10, [
      _cache[49] || (_cache[49] = _createElementVNode("div", { class: "title" }, "Free Rounds", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_icon, { icon: "coins" }),
        _cache[47] || (_cache[47] = _createTextVNode(" Stake Amount ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.parameters.freeRoundStake) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "..."
        }, null, 512), [
          [_vModelText, _ctx.parameters.freeRoundStake]
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_icon, { icon: "play" }),
        _cache[48] || (_cache[48] = _createTextVNode(" Total Rounds ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.parameters.freeRoundTotal) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "..."
        }, null, 512), [
          [_vModelText, _ctx.parameters.freeRoundTotal]
        ])
      ]),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.addFreeRounds && _ctx.addFreeRounds(...args)))
      }, "Submit")
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_11, [
      _cache[51] || (_cache[51] = _createElementVNode("div", { class: "title" }, "Auto Complete", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_icon, { icon: "gamepad" }),
        _cache[50] || (_cache[50] = _createTextVNode(" Round Id ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.parameters.autoCompleteGameRoundId) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "..."
        }, null, 512), [
          [_vModelText, _ctx.parameters.autoCompleteGameRoundId]
        ])
      ]),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.autoComplete && _ctx.autoComplete(...args)))
      }, "Submit")
    ]))
  ], 32))
}